export default __webpack_public_path__ + "static/media/dole-juice-module-hero@3x.52d93569.png";